module.exports = __webpack_public_path__ + "img/addSubScriptWhite.28c3f1f0.svg";